module.exports = __webpack_public_path__ + "img/icon_index_chongzi.0d251575.png";